function dateOnly(date: Date | null | undefined): string | null {
  if (date == null) {
    return null;
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const yearString = year.toString().padStart(4, '0');
  const monthString = month.toString().padStart(2, '0');
  const dayString = day.toString().padStart(2, '0');

  return `${yearString}-${monthString}-${dayString}`;
}

export default dateOnly;
